export default {
  appLoading: 'Loading the search application',
  added: 'no product added | 1 added product | {count} added products',
  variant_added: '{sku} was added in the cart.',
  application: 'Application',
  back_to_search: 'Back to search',
  category: 'Category | Categories',
  certification: 'Certification',
  certification_ab: 'Cert.',
  clone: 'Clone',
  conseil: 'Advice',
  couleur: 'Color',
  compare: 'Compare',
  compare_limit_reached_title: 'Unable to compare more products',
  compare_limit_reached: '{max} products max !',
  'comparedProductListBar.title': 'No selected products | Selected product | Selected produts',
  conjugué: 'Conjugate',
  dilution: 'Dilution',
  dilution_ab: 'Dil.',
  filter_by: 'Filter by',
  format: 'Format',
  highlight_differences: 'Hightlight Differences',
  hôte: 'Host',
  immunogène: 'Immunogen',
  isotype: 'Isotype',
  localisation: 'Localization',
  no_product_found: 'No product found.',
  'predicted reactivity': 'Prediction reactivity',
  pathologie: 'Pathology',
  presentation: 'Presentation',
  presentation_ab: 'Pres.',
  price: 'Price',
  product: 'product | products',
  products_title: 'no products found | 1 product found | {count} products found',
  products_compared: '{number} products selected',
  purification: 'Purification',
  quantity: 'Quantity',
  quantity_ab: 'Qty.',
  reactivity: 'Reactivity',
  réactivité: 'Reactivity',
  reference: 'Reference',
  reference_ab: 'Ref.',
  reinit: 'Reset',
  search_in_progress: 'Now searching',
  search_result: 'Search result:',
  spécificité: 'Specificity',
  suggested_products: 'Suggested products',
  supplier: 'Supplier',
  taille: 'Size',
  'tissus controles': 'Control Tissues',
  to_cart: 'to cart',
  vendor: 'Supplier',
  vendor_ab: 'Supp.',
  voir_moins: 'Less',
  voir_plus: 'More',
};
